export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.6 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const NAV_LINKS = [
  { label: "Why AuraXR", id: "why" },
  { label: "Experience", id: "experience" },
  { label: "Devices", id: "devices" },
  { label: "For Teachers", id: "teachers" },
  { label: "For Students", id: "students" },
  { label: "For Parents", id: "parents" },
  { label: "Future Classroom", id: "future" },
];

export const JOURNEY_STAGES = [
  {
    num: "01",
    title: "Explain",
    desc: "The teacher introduces the concept — the way she always has, chalk in hand.",
    img: "/images/journey-explain.jpg",
  },
  {
    num: "02",
    title: "Visualize",
    desc: "The concept becomes a spatial learning experience, anchored in the teaching area.",
    img: "/images/journey-visualize.jpg",
  },
  {
    num: "03",
    title: "Explore",
    desc: "Students observe and interact with the concept — walking around it, looking closer.",
    img: "/images/journey-explore.jpg",
  },
  {
    num: "04",
    title: "Understand",
    desc: "Students connect what they see with what they are learning. It clicks.",
    img: "/images/journey-understand.jpg",
  },
  {
    num: "05",
    title: "Reflect",
    desc: "The teacher reviews what students understood — and where more support may help.",
    img: "/images/journey-reflect.jpg",
  },
];

export const DEVICES = [
  {
    id: "teacher",
    name: "Teacher AR Glasses",
    tagline: "Guide. Control. Inspire.",
    desc: "Designed to help teachers guide and explain the learning experience.",
    img: "/images/device-teacher.png",
    hotspots: [
      { x: 41, y: 51, label: "Display", desc: "Shows relevant visual learning information." },
      { x: 53, y: 36, label: "Camera / Sensors", desc: "Conceptually helps understand the classroom environment." },
      { x: 90, y: 53, label: "Speaker", desc: "Supports audio interaction." },
      { x: 61, y: 47, label: "Microphone", desc: "Supports voice interaction." },
      { x: 18, y: 60, label: "Frame", desc: "Designed around comfortable classroom use." },
    ],
    extras: [
      { label: "AI Assistant", desc: "Conceptual on-demand assistance while teaching." },
      { label: "Content Library", desc: "Designed to bring ready visual learning content into the lesson." },
    ],
  },
  {
    id: "student",
    name: "Student AR Glasses",
    tagline: "See. Explore. Understand.",
    desc: "Designed to help students see, explore and understand — with a simple button to interact.",
    img: "/images/device-student.png",
    hotspots: [
      { x: 80, y: 55, label: "Display", desc: "Brings the lesson into view." },
      { x: 14, y: 46, label: "Speaker", desc: "Clear audio feedback." },
      { x: 78, y: 68, label: "Frame", desc: "Lightweight and comfortable." },
      { x: 37, y: 38, label: "Controls", desc: "A simple button to interact and respond." },
    ],
  },
  {
    id: "ring",
    name: "AuraRing",
    tagline: "Interact. Select. Respond.",
    desc: "A simple interaction layer for the student.",
    img: "/images/device-ring.png",
    interactions: [
      { label: "Select", desc: "Choose options with a gesture." },
      { label: "Confirm", desc: "Confirm actions with ease." },
      { label: "Navigate", desc: "Move through content naturally." },
      { label: "Respond", desc: "Answer and interact quickly." },
      { label: "Interact", desc: "A quiet layer between student and lesson." },
    ],
    note: "No camera. Designed only for interaction.",
  },
];

export const SUBJECTS = [
  {
    id: "biology",
    name: "Biology",
    desc: "Explore the human body beyond the textbook.",
    img: "/images/subject-biology.jpg",
  },
  {
    id: "chemistry",
    name: "Chemistry",
    desc: "See molecules and reactions take shape.",
    img: "/images/subject-chemistry.jpg",
  },
  {
    id: "physics",
    name: "Physics",
    desc: "See forces and motion in action.",
    img: "/images/subject-physics.jpg",
  },
  {
    id: "mathematics",
    name: "Mathematics",
    desc: "Understand shapes and space differently.",
    img: "/images/subject-math.jpg",
  },
  {
    id: "history",
    name: "History",
    desc: "Bring places and moments closer to the classroom.",
    img: "/images/subject-history.jpg",
  },
  {
    id: "geography",
    name: "Geography",
    desc: "Explore the world spatially.",
    img: "/images/subject-geography.jpg",
  },
];

export const TEACHER_BENEFITS = [
  { title: "Visualize", desc: "Turn abstract concepts into something students can see." },
  { title: "Demonstrate", desc: "Show concepts that are difficult to demonstrate physically." },
  { title: "Engage", desc: "Give students something meaningful to observe and explore." },
  { title: "Guide", desc: "Help teachers guide the learning experience." },
];

export const PROBLEM_STORIES = [
  {
    role: "For Teachers",
    quote: "How do I make a difficult concept easier to demonstrate?",
    img: "/images/problem-teacher.jpg",
  },
  {
    role: "For Students",
    quote: "I can hear the explanation. I just can't picture it.",
    img: "/images/problem-student.jpg",
  },
  {
    role: "For Parents",
    quote: "How can I understand where my child needs help?",
    img: "/images/problem-parent.jpg",
  },
];

export const PERSPECTIVES = [
  {
    role: "Teacher",
    line: "Explain with more possibilities.",
    img: "/images/perspective-teacher.jpg",
  },
  {
    role: "Student",
    line: "See, explore and understand.",
    img: "/images/perspective-student.jpg",
  },
  {
    role: "Parent",
    line: "Understand progress beyond a report card.",
    img: "/images/perspective-parent.jpg",
  },
];
